
var id = "tupianguanli";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 792 792\" id=\"tupianguanli\">\n<style type=\"text/css\">\n\t#tupianguanli .st0{clip-path:url(#tupianguanli_SVGID_2_);}\n</style>\n<g>\n\t<g>\n\t\t<defs>\n\t\t\t<rect id=\"tupianguanli_SVGID_1_\" y=\"128.15\" width=\"792\" height=\"535.71\" />\n\t\t</defs>\n\t\t<clipPath id=\"tupianguanli_SVGID_2_\">\n\t\t\t<use xlink:href=\"#tupianguanli_SVGID_1_\" style=\"overflow:visible;\" />\n\t\t</clipPath>\n\t\t<path class=\"st0\" d=\"M786.61,618.91L578.34,364.09c-3.7-4.63-9.4-7.4-15.26-7.56c-5.86-0.15-11.72,2.16-15.72,6.47L440.68,476.62\n\t\t\tL288.21,233.2c-3.7-6.01-10.33-9.71-17.42-9.71c-7.1,0-13.72,3.7-17.43,9.71L3.16,632.17c-6.01,9.72-3.24,22.51,6.47,28.52\n\t\t\tc9.72,6.01,22.52,3.24,28.52-6.47l232.47-371.06l232.48,371.06c6.01,9.71,18.65,12.49,28.52,6.47\n\t\t\tc9.71-6.01,12.49-18.65,6.47-28.52l-74.92-119.47l98.04-104.21L754.7,645.12c7.09,8.78,20.2,10.17,28.99,2.93\n\t\t\tC792.62,640.8,793.85,627.7,786.61,618.91L786.61,618.91z M664.05,330.48c1.38,0,2.62,0,4.01-0.15\n\t\t\tc53.96-2.16,96.19-46.56,96.19-100.05c0-1.38,0-2.62-0.15-4c-2.16-53.96-46.56-96.2-100.05-96.2c-1.39,0-2.62,0-4.01,0.15\n\t\t\tc-53.96,2.16-96.2,46.56-96.2,100.05c0,1.39,0,2.78,0.16,4C566.16,288.23,610.55,330.48,664.05,330.48L664.05,330.48z\n\t\t\t M661.74,171.39h2.31c31.45,0,57.5,24.97,58.74,56.57v2.31c0,31.45-24.82,57.5-56.57,58.74l-2.31,0.15\n\t\t\tc-31.45,0-57.5-24.97-58.74-56.58v-2.16C605.16,198.82,630.13,172.61,661.74,171.39L661.74,171.39z M661.74,171.39\" />\n\t</g>\n</g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
